export default __webpack_public_path__ + "static/media/news3.27e8643c.png";